import { encodeStructuredDocument, type StructureMapping, type StructuredValue } from '@adornis/web-editor/nodes/structured-document.js';
import type { LandingEditorProject } from './landingEditorTypes.js';

export const landingStructureMapping: StructureMapping = {
  kind: path => {
    if (!path.length) return 'site';
    if (path[0] === 'content' && path.length === 2 || path[0] === 'staticPages' && path.length === 2) return 'locale';
    if (path[0] === 'staticPages' && path.length === 3) return 'audience';
    if (path[0] === 'staticPages' && path.length === 4) return 'page';
    if (path[0] === 'content' && path.length === 3) return 'section';
    if (/^\d+$/u.test(path.at(-1) ?? '')) return 'repeat';
    return 'container';
  },
};
export const projectToDocument = (project: LandingEditorProject) =>
  encodeStructuredDocument(JSON.parse(JSON.stringify(project)) as StructuredValue, landingStructureMapping);
